<template>
  <AddStudent />
</template>
<script>
import appConfig from '@/app.config'
import AddStudent from '../../../components/dadban/students/AddStudent.vue'
export default {
  page: {
    title: 'اضافه کردن دانش پذیر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-students',
  components: {
    AddStudent,
  },
}
</script>
